import { Button, Checkbox, FormControlLabel, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTiposClausulasCertificado } from "../../../../redux/actions/certificadoCobertura";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { StyledClausula } from "../../../styled/Personal";
import EmpresaContainer from "./empresa/EmpresaContainer";

const ClausulaContainer = ({ nextForm }) => {
  const dispatch = useDispatch();

  const tiposClausulas = useSelector(
    (state) => state.certificadoCobertura.clausulas
  );

  const [clausulasChecked, setClausulasChecked] = useState([]);
  const [empresaList, setEmpresaList] = useState([]);
  const [usarCargaPorTexto, setUsarCargarPorTexto] = useState(false);

  const clausulaSubrogacionSeleccionada = clausulasChecked.some(
    (id) => id.toUpperCase() === "CS"
  );
  const mostrarTablaEmpresas = clausulaSubrogacionSeleccionada;
  const usuarioNoPuedeContinuar =
    clausulaSubrogacionSeleccionada && empresaList.length === 0;

  useEffect(() => {
    if (tiposClausulas.data.length === 0) {
      dispatch(getTiposClausulasCertificado());
    }
  }, []);

  const handleChange = (event, clausula) => {
    const clausulasAux = [...clausulasChecked];
    if (event.target.checked) {
      clausulasAux.push(clausula.id);
    } else {
      const index = clausulasAux.indexOf(clausula.id);
      if (index > -1) {
        clausulasAux.splice(index, 1);
      }
    }
    setClausulasChecked(clausulasAux);
  };

  // Si el usuario carga las empresas por texto, al back
  // le vamos a enviar ese string (con un formato arbitrario)
  // en el primer objeto de la lista de empresas.
  const handleSubmitEmpresasCargaDirecta = (empresas) => {
    // Tenemos que sobreescribir la lista de empresas cargadas por tabla.
    setEmpresaList([empresas]);
  };

  return (
    <StyledClausula.Container >
      {tiposClausulas.loading ? (
        <StyledClausula.LoadingContainer>
          <CircularLoading />
        </StyledClausula.LoadingContainer>
      ) : (
        <StyledClausula.ContentContainer>
          <StyledClausula.ClausulasContainer>
            <FormControlLabel
              control={<Switch />}
              onChange={() => {
                // Activar el Switch de "carga por texto" deberia
                // borrar la lista de empresas cargadas por tabla.
                // Esto es porque, al cargar por texto, necesitamos enviar
                // 1 solo objeto en la lista de empresas.
                // La tabla carga 1 objeto por 1 fila, entonces no podemos
                // haber cargado empresas en la tabla y luego cargar por texto.
                setEmpresaList([]);
                setUsarCargarPorTexto((prev) => !prev);
              }}
              disabled={!clausulaSubrogacionSeleccionada}
              label="Carga por texto"
            />
            {tiposClausulas.data.map((clausula) => (
              <FormControlLabel
                key={clausula.id}
                control={
                  <Checkbox
                    sx={{
                      "&.Mui-checked": {
                        color: "#007864",
                      },
                    }}
                    onChange={(e) => handleChange(e, clausula)}
                  />
                }
                label={clausula.nombre}
              />
            ))}
          </StyledClausula.ClausulasContainer>
          {mostrarTablaEmpresas && (
            <EmpresaContainer
              empresaList={empresaList}
              setEmpresaList={setEmpresaList}
              mostrarCargaPorTexto={usarCargaPorTexto}
              handleCargarEmpresasPorTexto={handleSubmitEmpresasCargaDirecta}
            />
          )}
        </StyledClausula.ContentContainer>
      )}
      <StyledClausula.Button>
        <Button
          color="primary"
          variant="contained"
          disabled={usuarioNoPuedeContinuar ? true : false}
          onClick={() => nextForm(clausulasChecked, empresaList)}
        >
          Siguiente
        </Button>
      </StyledClausula.Button>
    </StyledClausula.Container>
  );
};

export default ClausulaContainer;
